import * as yup from "yup"
import {
  courseRegistrationCourseWithEquipmentValidationSchema,
  courseRegistrationIsSignValidationSchema,
  emailValidationSchema,
  firstnameValidationSchema,
  lastnameValidationSchema,
  referralSourceValidationSchema,
  relationToStudentValidationSchema,
  schoolRegionValidationSchema,
  schoolValidationSchema,
  yearOfStudiesValidationSchema
} from "../validations/courseREgistrationValidationSchemas"
import { phoneYupValidationSchema } from "../phoneRegExp"
import { withGiftVoucherValidationSchema } from "../WithGiftVoucherFormItem"
import { invoiceSchema } from "./invoiceSchema"

export const getRegisterFormValidationSchema = (courseWithEquipment: boolean, coursePrice: number) =>
  yup.object().shape({
    student: yup.object().shape({
      firstname: firstnameValidationSchema,
      lastname: lastnameValidationSchema,
      yearOfStudies: yearOfStudiesValidationSchema,
      schoolRegion: schoolRegionValidationSchema,
      school: schoolValidationSchema,
      email: emailValidationSchema
    }),
    studentContact: yup.object().shape({
      firstname: firstnameValidationSchema,
      lastname: lastnameValidationSchema,
      email: emailValidationSchema,
      phone: phoneYupValidationSchema,
      relationToStudent: relationToStudentValidationSchema
    }),
    iSignUp: courseRegistrationIsSignValidationSchema,
    newsletterAgreement: yup.boolean(),
    ...withGiftVoucherValidationSchema,
    ...(courseWithEquipment && courseRegistrationCourseWithEquipmentValidationSchema),
    coupon: yup.string(),
    referralSource: referralSourceValidationSchema,
    consent: yup.boolean().oneOf([true], "Prosím zatrněte souhlas.").required(),
    ...(coursePrice > 0 && { invoice: invoiceSchema })
  })
